export const Eyebrow = ({ number, children }: { number?: string; children: React.ReactNode }) => (
  <p className="text-eyebrow">— {number ? `${number} / ` : ""}{children}</p>
);
export default Eyebrow;
